module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAWklEQVR4Ae3WAQbAMBBE0Rw7QKOwhy7S7h1KDO8xB/hIkgEAAHDQPcI93yo9YHdEekCv0gN6Kz2gd40f7UOb6QG9mR6wkgMq+RBX8i1U4wwPWfnMJX2nAQAAXu97n3PizmfyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Entityview/baseline_arrow_right_alt_black_24dp.png
// module id = 91
// module chunks = 0